import { ko as common } from "./common/ko.yml";
import { ko as managerCompany } from "./managerCompany/ko.yml";
import { ko as adminTop } from "./adminTop/ko.yml";
import { ko as adminUser } from "./adminUser/ko.yml";
import { ko as companyAdminUser } from "./companyAdminUser/ko.yml";
import { ko as company } from "./company/ko.yml";
import { ko as companyInvoice } from "./companyInvoice/ko.yml";
import { ko as companyPayment } from "./companyPayment/ko.yml";
import { ko as hotel } from "./hotel/ko.yml";
import { ko as hotelRoom } from "./hotelRoom/ko.yml";
import { ko as hotelRoomChildrenSetting } from "./hotelRoomChildrenSetting/ko.yml";
import { ko as hotelPlan } from "./hotelPlan/ko.yml";
import { ko as hotelCancelPolicy } from "./hotelCancelPolicy/ko.yml";
import { ko as hotelChildrenSetting } from "./hotelChildrenSetting/ko.yml";
import { ko as hotelPlanChildrenSetting } from "./hotelPlanChildrenSetting/ko.yml";
import { ko as hotelQuestion } from "./hotelQuestion/ko.yml";
import { ko as hotelOption } from "./hotelOption/ko.yml";
import { ko as hotelFilter } from "./hotelFilter/ko.yml";
import { ko as hotelMail } from "./hotelMail/ko.yml";
import { ko as hotelWaitingList } from "./hotelWaitingList/ko.yml";
import { ko as hotelInventory } from "./hotelInventory/ko.yml";
import { ko as hotelPrice } from "./hotelPrice/ko.yml";
import { ko as hotelScript } from "./hotelScript/ko.yml";
import { ko as hotelCheckIn } from "./hotelCheckIn/ko.yml";
import { ko as hotelCheckInQuestion } from "./hotelCheckInQuestion/ko.yml";
import { ko as hotelPushMessageGroup } from "./hotelPushMessageGroup/ko.yml";
import { ko as hotelCalendar } from "./hotelCalendar/ko.yml";
import { ko as booking } from "./booking/ko.yml";
import { ko as notification } from "./notification/ko.yml";
import { ko as promotion } from "./promotion/ko.yml";
import { ko as user } from "./user/ko.yml";
import { ko as newsletter } from "./newsletter/ko.yml";

export const componentKo: any = {
  common: common["adminComponentCommon"],
  managerCompany: managerCompany["adminComponentManagerCompany"],
  adminTop: adminTop["adminComponentAdminTop"],
  adminUser: adminUser["adminComponentAdminUser"],
  companyAdminUser: companyAdminUser["adminComponentCompanyAdminUser"],
  company: company["adminComponentCompany"],
  companyInvoice: companyInvoice["adminComponentCompanyInvoice"],
  companyPayment: companyPayment["adminComponentCompanyPayment"],
  hotel: hotel["adminComponentHotel"],
  hotelRoom: hotelRoom["adminComponentHotelRoom"],
  hotelRomChildrenSetting:
    hotelRoomChildrenSetting["adminComponentHotelRoomChildrenSetting"],
  hotelPlan: hotelPlan["adminComponentHotelPlan"],
  hotelCancelPolicy: hotelCancelPolicy["adminComponentHotelCancelPolicy"],
  hotelChildrenSetting:
    hotelChildrenSetting["adminComponentHotelChildrenSetting"],
  hotelPlanChildrenSetting:
    hotelPlanChildrenSetting["adminComponentHotelPlanChildrenSetting"],
  hotelQuestion: hotelQuestion["adminComponentHotelQuestion"],
  hotelOption: hotelOption["adminComponentHotelOption"],
  hotelFilter: hotelFilter["adminComponentHotelFilter"],
  hotelMail: hotelMail["adminComponentHotelMail"],
  hotelWaitingList: hotelWaitingList["adminComponentHotelWaitingList"],
  hotelInventory: hotelInventory["adminComponentHotelInventory"],
  hotelPrice: hotelPrice["adminComponentHotelPrice"],
  hotelScript: hotelScript["adminComponentHotelScript"],
  hotelCheckIn: hotelCheckIn["adminComponentHotelCheckIn"],
  hotelCheckInQuestion:
    hotelCheckInQuestion["adminComponentHotelCheckInQuestion"],
  hotelPushMessageGroup:
    hotelPushMessageGroup["adminComponentHotelPushMessageGroup"],
  hotelCalendar: hotelCalendar["adminComponentHotelCalendar"],
  booking: booking["adminComponentBooking"],
  notification: notification["adminComponentNotification"],
  promotion: promotion["adminComponentPromotion"],
  user: user["adminComponentUser"],
  newsletter: newsletter["adminComponentNewsletter"],
};
